const defaultLocale = {
  code: "en-US"
};
export {
  defaultLocale
};
//# sourceMappingURL=defaultLocale.js.map
